import SectionLabel from '../ui/SectionLabel';
import SectionTitle from '../ui/SectionTitle';
import BtnPrimary from '../ui/BtnPrimary';
import { useScrollReveal } from '../../hooks/useScrollReveal';
import { useAppContext } from '../../context/AppContext';
import { LandingTrans } from '../../utils/translations';

export default function HowToSection() {
  const { language } = useAppContext();
  const t = LandingTrans[language];
  const [ref, visible] = useScrollReveal();

  const steps = [
    { num: '01', titleKey: 'step1Title', textKey: 'step1Text' },
    { num: '02', titleKey: 'step2Title', textKey: 'step2Text' },
    { num: '03', titleKey: 'step3Title', textKey: 'step3Text' },
  ];

  return (
    <section
      ref={ref}
      className={`bg-white py-16 md:py-30 px-6 md:px-20 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
    >
      <div className="max-w-6xl mx-auto">
        <SectionLabel>
          {t.howToLabel}
        </SectionLabel>
        <SectionTitle className="mt-4 mb-14 text-ink">
          {t.howToTitle}<em className="italic text-clay">{t.howToTitleEm}</em>
        </SectionTitle>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-px rounded-sm overflow-hidden bg-sand-dark">
          {steps.map((step, idx) => (
            <div
              key={idx}
              className="bg-white p-10 border border-sand-dark hover:bg-sand/50 transition-colors"
            >
              <p className="font-serif text-5xl font-normal text-clay/70 mb-4">{step.num}</p>
              <h3 className="text-base font-sans font-medium text-ink text-center mb-3">{t[step.titleKey]}</h3>
              <p className="text-sm font-sans font-light text-ink-mid leading-relaxed" style={{ lineHeight: 1.7 }}>
                {t[step.textKey]}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-10 md:flex md:justify-start">
          <BtnPrimary href="/schedule">
            {t.signUpClass}
          </BtnPrimary>
        </div>
      </div>
    </section>
  );
}
